import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import UidDashboardTimelineComponent from "./component";

const UidDashboardTimelineContainer = (props) => {
  const navigate = useNavigate();
  const { uid } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uidTimelineDetails, setUidTimelineDetails] = useState(null);

  // Determine the current mode based on the route
  const getCurrentMode = () => {
    if (location.pathname.includes('/uid-unmap/')) {
      return 'unmap';
    } else if (location.pathname.includes('/uid-map/')) {
      return 'map';
    } else {
      return 'details';
    }
  };

  const currentMode = getCurrentMode();

  useEffect(() => {
    if (uid) {
      loadUidDetails(uid);
    }
  }, [uid]);

  // Function to load UID details
  const loadUidDetails = (uid) => {
    setLoading(true);
    setError(null);
    
    props.getDataFromAPI(
      `/partner/api/v2/timeline/${uid}`,
      "GET",
      undefined,
      (response) => {
        console.log("UID Details API Response:", response);
        setUidTimelineDetails(response);
        setLoading(false);
      },
      (error) => {
        console.error("UID Details API Error:", error);
        setError("Failed to fetch UID details");
        setLoading(false);
      }
    );
  };

  // Handle unmap action
  const handleUnmap = (reason) => {
    if (!uidTimelineDetails) return;
    
    setLoading(true);
    
    const unmapPayload = {
      uids: [uid], // Array of UIDs
      vmId: 7, // Array of VM IDs (using 1 as default)
      reason: reason
    };

    // Call unmap API
    props.getDataFromAPI(
      `/partner/api/v2/uid-vm/unmap`,
      "POST",
      unmapPayload,
      (response) => {
        console.log("Unmap API Response:", response);
        // alert(`Successfully unmapped UID ${uidValue}! Reason: ${reason}`);
        
        // Go back to dashboard after successful unmapping
        navigate('/home/configuration/uid-dashboard');
      },
      (error) => {
        console.error("Unmap API Error:", error);
        setError("Failed to unmap UID");
        setLoading(false);
      }
    );
  };

  // Handle map action (you'll need to implement this based on your API)
  const handleMap = (vmid, reason) => {
    if (!uidTimelineDetails) return;
    
    setLoading(true);
    
    const mapPayload = {
      uids: [uid], // Array of UIDs
      vmIds: [vmid], // Array of VM IDs
      reason: reason || "Mapping UID to VM"
    };

    // Call map API (you'll need to create this endpoint)
    props.getDataFromAPI(
      `/partner/api/v2/uids/map`,
      "POST",
      mapPayload,
      (response) => {
        console.log("Map API Response:", response);
        alert(`Successfully mapped UID ${uid} to VMID ${vmid}!`);
        
        // Go back to dashboard after successful mapping
        navigate('/home/configuration/uid-dashboard');
      },
      (error) => {
        console.error("Map API Error:", error);
        setError("Failed to map UID");
        setLoading(false);
      }
    );
  };

  return (
    <UidDashboardTimelineComponent
      uidTimelineDetails={uidTimelineDetails}
      loading={loading}
      error={error}
      navigate={navigate}
      uid={uid}
     
    />
  );
};

export default connect(null, {
  getDataFromAPI,
})(UidDashboardTimelineContainer);